import Vue from 'vue';
import siteService from '@/project/site/site.service';
import dictionaryService from '@/core/translation/dictionary.service';

const locale = siteService.getCulture();

const symbols = [
    '',
    '', // dictionaryService.get('Generic.Number.Thousand'),
    dictionaryService.get('Generic.Number.Million')];

function abbreviateNumber(
    num: number,
    digit: number = 1,
    padding: boolean = false
): string {
    // handle negatives
    const sign = Math.sign(num) >= 0;
    num = Math.abs(num);
    const numFormated = locale ? num.toLocaleString(locale) : num.toString();

    // what tier? (determines SI symbol)
    const tier = (Math.log10(num) / 3) | 0;

    // if zero, we don't need a suffix
    if (tier === 0) return (!sign ? '-' : '') + numFormated;

    // get suffix and determine scale
    const suffix = symbols[tier];
    if (!suffix) return numFormated;

    const scale = Math.pow(10, tier * 3);

    // scale the number
    const scaled = num / scale;

    let rounded = scaled.toFixed(digit);
    if (!padding) {
        rounded = String(Number(rounded));
    }

    // format number and add suffix
    return `${(!sign ? '-' : '')} ${rounded} ${suffix}`;
}

Vue.filter('abbreviate', abbreviateNumber);

export default abbreviateNumber;
